import { useCallback } from "react";

import { useRouter } from "next/navigation";

import { pushGtmEvent } from "@/utils/gtm";

interface RedirectToSubscriptionProps {
  subscriptionEnabled: boolean;
  isFreezeProduct: boolean;
}

// サブスクの管理ページに飛ぶためのメソッドを提供する
export default function useRedirectToSubscription({
  subscriptionEnabled,
  isFreezeProduct,
}: RedirectToSubscriptionProps) {
  const router = useRouter();

  const redirectToSubscription = useCallback(() => {
    pushGtmEvent({
      event: "productPageClickButton",
      button_type: (subscriptionEnabled ? "subscription_" : "normal_") + "redirectMypage",
    });
    if (isFreezeProduct) {
      router.push("/mypage/freeze_subscription?anchor=order-summary");
      return;
    }

    router.push("/mypage/subscription?anchor=order-summary");
  }, [isFreezeProduct, router, subscriptionEnabled]);

  return { redirectToSubscription };
}
